import { createCreatePartnerValidator, createUpdatePartnerValidator, } from "#validators/partners.validator.factory";
// Use factory functions with pass-through translation for type inference
const createPartnerValidatorForType = createCreatePartnerValidator((key) => key);
const updatePartnerValidatorForType = createUpdatePartnerValidator((key) => key);
